import { makeStyles } from '@material-ui/core';
import React, { useEffect } from 'react';

import { Colors } from 'src/common/ui/base/Colors';
import { NAV_HEIGHT } from 'src/components/app/Nav/Nav';
import { OBSERVABILITY_MY_DAY_TODAY, SHOW_MDT_SANDBOX } from 'src/featureFlags/currentFlags';
import { useFeatureFlag } from 'src/featureFlags/useFeatureFlag';
import { Sandbox } from 'src/myDayToday/Sandbox';
import { ScheduleWidget } from 'src/myDayToday/ScheduleWidget';
import { TopBar } from 'src/myDayToday/TopBar';
import { CurrentStatusSection } from 'src/myDayToday/components/CurrentStatusSection';
import { SectionErrorBoundary } from 'src/myDayToday/components/SectionErrorBoundary';
import { VisitsSection } from 'src/myDayToday/components/VisitsSection';
import { useMDTEventCards } from 'src/myDayToday/domain/useMDTEventCards';
import { useProviderId } from 'src/myDayToday/domain/useProviderId';
import { useObservability } from 'src/observability/useObservability';

export const MyDayTodayV2 = () => {
  const enableObservability = useFeatureFlag(OBSERVABILITY_MY_DAY_TODAY);
  const showSandbox = useFeatureFlag(SHOW_MDT_SANDBOX);
  const sendStaffEvent = useObservability(enableObservability);
  const styles = useStyles();
  const providerId = useProviderId();
  useMDTEventCards(providerId);

  useEffect(
    () =>
      sendStaffEvent({
        eventType: 'myDayToday:pageViewed',
        userId: providerId ?? null,
      }),
    [providerId, sendStaffEvent],
  );

  if (!providerId) {
    return <div className={styles.container}>No provider ID found</div>;
  }

  return (
    <>
      <main className={styles.main}>
        <SectionErrorBoundary sectionName="Header">
          <TopBar />
        </SectionErrorBoundary>
        <div className={styles.container}>
          <SectionErrorBoundary sectionName="CurrentStatus">
            <CurrentStatusSection providerId={providerId} />
          </SectionErrorBoundary>
          <div className={styles.contentRow}>
            <div className={styles.scheduleColumn}>
              <SectionErrorBoundary sectionName="Schedule">
                <ScheduleWidget providerId={providerId} />
              </SectionErrorBoundary>
            </div>
            <div className={styles.visitsColumn}>
              <SectionErrorBoundary sectionName="Visits">
                <VisitsSection />
              </SectionErrorBoundary>
            </div>
          </div>
        </div>
      </main>
      {showSandbox && <Sandbox />}
    </>
  );
};

const useStyles = makeStyles({
  main: {
    height: `calc(100vh - ${NAV_HEIGHT}px)`,
    backgroundColor: Colors.CoolGray1,
    overflow: 'auto',
  },
  container: {
    boxSizing: 'border-box',
    fontFamily: '"Nunito", "Nunito Sans"',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'stretch',
    padding: 24,
    gap: 16,
  },
  contentRow: {
    display: 'flex',
    flexDirection: 'row',
    gap: 24,
    alignItems: 'stretch',
    '@media (max-width: 877px)': {
      flexDirection: 'column',
    },
  },
  scheduleColumn: {
    flexShrink: 0,
    width: 474,
    '@media (max-width: 877px)': {
      width: '100%',
    },
  },
  visitsColumn: {
    flex: '1 0 0',
    minWidth: 0,
  },
});
